// extracted by mini-css-extract-plugin
module.exports = {"modal":"ui","error":"vi","disabled":"wi","fields":"xi","footer":"yi"};